export default __webpack_public_path__ + "static/media/video-2.99ba0385.jpg";